import { useCallback } from "react";
import { Marker, MarkerProps, Tooltip } from "react-leaflet";
import { tooltipStyles } from "../map-displays/mapStyles";
import { airportIcon } from "./marker-icons/airportIcon";

export interface IAirportMarkersProps {
  code: string;
  name: string;
  position: MarkerProps["position"];
  handleMarkerClick?: (zoom: number) => void;
}

const AirportMarkers: React.FC<IAirportMarkersProps> = ({
  code,
  name,
  position,
  handleMarkerClick,
}: IAirportMarkersProps) => {
  const classes = tooltipStyles();

  const handleViewChange = useCallback(() => {
    handleMarkerClick?.(14);
  }, [handleMarkerClick]);

  return (
    <Marker
      position={position}
      icon={airportIcon}
      eventHandlers={{ click: handleViewChange }}
    >
      <Tooltip direction="top" className={classes.tooltip}>
        {code} - {name}
      </Tooltip>
    </Marker>
  );
};

export default AirportMarkers;
